export default "/images/vendor/flag-icon-css/flags/1x1/vn.svg?25540177a9e64be64b71d743cec8a669";